import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
// import Promotion from '@/components/sections/Promotion'
import BookNowForm from '@/components/book-storage-facility/bookNowForm'
import Configs from '@/configs'
import CookieKeys from '@/configs/caching/keys/cookie'
import { encrypt } from '@/helpers/common'
import store from '@/store/configureStore'
import {
  ADMIN_AS_USER_LOGIN,
  ADMIN_AS_USER_LOGIN_FAILED,
  ADMIN_AS_USER_LOGIN_START
} from '@/store/constants/actionTypes'
import { tokensToRemove } from '@/store/sagas/auth'
import { removeCookies, setEncryptedCookie } from '@/v1/lib/cookie'
import HomePage from '@/v2/components/pages/public-pages/home-page'
import axios from 'axios'
import { useRouter } from 'next/router'
import React from 'react'

// import { useRouter } from 'next/router'

function Home() {
  const router = useRouter()
  React.useEffect(() => {
    let isMounted = true

    if (router.isReady) {
      const { query } = router

      const customerAuthToken = query.customerAuthToken
      const orderId = query?.order_id

      if (customerAuthToken && typeof customerAuthToken === 'string' && customerAuthToken !== '') {
        adminLoginAsUser(customerAuthToken.trim()).then(response => {
          if (!isMounted) return

          if (response.success) {
            const cleanedQuery = { ...query }
            delete cleanedQuery.customerAuthToken
            delete cleanedQuery.order_id

            const baseUrl = window.location.origin // current domain

            const redirectUrl = orderId ? `${baseUrl}/order-processing/${encrypt(orderId)}` : baseUrl // fallback to homepage

            router.replace(redirectUrl).then(() => router.reload())
          }
        })
      }
    }

    return () => {
      isMounted = false
    }
  }, [router.isReady, router])

  return (
    <>
      <Meta
        title={META_CONTENTS.home.title}
        keywords={META_CONTENTS.home.keywords}
        description={META_CONTENTS.home.description}
      />

      <BookNowForm />
      {/*
      <HomeBanner />

      <Features />

      <WhyDifferent />

      <CustomizedSolution />

      <StorageFeatures />

      <Reviews /> */}

      {/*<Promotion />*/}
      <HomePage />
    </>
  )
}

export default Home

export async function adminLoginAsUser(token: string) {
  try {
    if (token) {
      store.dispatch({ type: ADMIN_AS_USER_LOGIN_START })
      const instance = axios.create({
        baseURL: Configs.apiBaseURL,
        headers: {
          'Content-Type': 'application/json'
        }
      })

      const result = await instance.post('/simulateUserLogin', { token })
      // console.log(result.data)
      if (result.status === 200 && result.data.status) {
        setEncryptedCookie(CookieKeys.accessToken, result.data.access_token)
        setEncryptedCookie(CookieKeys.tokenType, result.data.token_type)
        setEncryptedCookie(CookieKeys.expiresIn, result.data.expires_in)

        // dispatch action to redux or return data for caller
        store.dispatch({ type: ADMIN_AS_USER_LOGIN, data: result.data.data })

        return { success: true, data: result.data.data }
      } else {
        removeCookies(tokensToRemove)
        store.dispatch({ type: ADMIN_AS_USER_LOGIN_FAILED })

        return { success: false }
      }
    } else {
      store.dispatch({ type: ADMIN_AS_USER_LOGIN_FAILED })

      return { success: false }
    }
  } catch (error) {
    // store.dispatch({ type: types.HEADER_ERROR, error })
    return { success: false, error }
  }
}
